import { Tag, Tooltip } from "@homebound/beam";
import { pluralize } from "src/utils";

type PrerequisitesTagProps = { prerequisites: { id: string; name: string; code?: string }[] };
export function PrerequisitesTag({ prerequisites }: PrerequisitesTagProps) {
  if (prerequisites.isEmpty) return null;
  const count = prerequisites.length;
  return (
    <Tooltip
      data-testid="prerequisites-tooltip"
      title={
        <div>
          <div>{`${pluralize(prerequisites, "Prerequisite")}:`}</div>
          {prerequisites.map((c) => (
            <div key={c.id}>
              {c.name} {c.code}
            </div>
          ))}
        </div>
      }
      placement="top"
    >
      <Tag text={`${count} ${pluralize(count, "prerequisite")}`} type="update" />
    </Tooltip>
  );
}
